module.exports = __webpack_public_path__ + "static/media/tsc-cards.f9ec8fdf.png";